export const translations = {
  screen_id: "Layar",
  screen_en: "Screens",
  location_id: "Lokasi",
  location_en: "Locations",
  city_id: "Kota/Kabupaten",
  city_en: "City",
  city_label_id: "Kota",
  city_label_en: "City",
  city_in_id: "Kota di Indonesia",
  city_in_en: "Cities in Indonesia",
  gallery_id: "Galeri",
  gallery_en: "Gallery",
  address_en: "Address",
  address_id: "Alamat",
  concession_id: "Makanan dan Minuman",
  concession_en: "Food and Beverages",
  cinema_id: "Teater",
  cinema_en: "Cinema",
  services_id: "Layanan",
  services_en: "Services",
  not_found_cinema_title_en: "No cinema outlets found",
  not_found_cinema_title_id: "Tidak ada gerai bioskop yang ditemukan",
  not_found_cinema_text_en: "Try searching other cities or cinema locations",
  not_found_cinema_text_id: "Coba cari kota atau lokasi bioskop lain",
  not_found_jobs_title_en: "No vacancies found",
  not_found_jobs_title_id: "Tidak ada lowongan yang ditemukan",
  not_found_jobs_text_en: "Try again on another time",
  not_found_jobs_text_id: "Coba lagi di lain waktu",
  sc_find_cinema_title_en: (title) => `Find ${title || "Cinema XXI"} near you`,
  sc_find_cinema_title_id: (title) => `Temukan ${title || "bioskop"} terdekat`,
  sc_find_cinema_text_en: "View All Locations",
  sc_find_cinema_text_id: "Tampilkan Semua Bioskop",
  loc_detail_concession_title_en: "Available Foods and Beverages",
  loc_detail_concession_title_id: "Makanan dan Minuman yang Tersedia",
  loc_detail_concession_text_en:
    "Choose from our selection of food and beverage whether you just need a bite or to accompany your movie experience.",
  loc_detail_concession_text_id:
    "Pilih dari pilihan makanan dan minuman kami apakah Anda hanya ingin makan atau untuk menemani pengalaman menonton film Anda.",
  loc_detail_concession_text_btn_en: "View All XXI Foods and Beverages",
  loc_detail_concession_text_btn_id: "Lihat Semua Makanan dan Minuman XXI",
  loc_detail_theaters_title_en: "Available Theaters",
  loc_detail_theaters_title_id: "Bioskop yang Tersedia",
  loc_detail_theaters_text_en:
    "Enjoy immersive movie experience through our world class cinema technologies.",
  loc_detail_theaters_text_id:
    "Nikmati pengalaman film imersif melalui teknologi sinema kelas dunia kami.",
  loc_detail_theaters_text_btn_en: "View All XXI Theaters",
  loc_detail_theaters_text_btn_id: "Lihat Semua Teater XXI",
  view_detail_en: "See Details",
  view_detail_id: "Lihat Detail",
  awards_title_en: "Awards throughout the years",
  awards_title_id: "Penghargaan sepanjang tahun",
  awards_text_en:
    "For its commitment and hard work in providing the best movie-viewing experience, Cinema XXI has been rewarded various awards both in national and international levels",
  awards_text_id:
    "Atas komitmen dan kerja kerasnya dalam memberikan pengalaman menonton film terbaik, Cinema XXI telah diganjar berbagai penghargaan baik di tingkat nasional maupun internasional",
  concession_location_en: (title) => `Find ${title} around you`,
  concession_location_id: (title) => `Temukan ${title} disekitar mu`,
  concession_location_ballroom_en: "Find Our Location",
  concession_location_ballroom_id: "Temukan Lokasi Kami",
  not_found_concession_title_en: (title) => `No ${title} outlets found`,
  not_found_concession_title_id: (title) =>
    `Tidak ada gerai ${title} yang ditemukan`,
  not_found_concession_text_en:
    "Try searching other cities or cinema locations",
  not_found_concession_text_id: "Coba cari kota atau lokasi bioskop lain",
  view_google_maps_en: "View in Google Maps",
  view_google_maps_id: "Lihat di Google Maps",
  location_total_en: (total) => `${total} Outlets Found`,
  location_total_id: (total) => `${total} Outlet ditemukan`,
  location_landing_title_en: "All Cinema XXI Outlets",
  location_landing_title_id: "Semua Outlet Cinema XXI",
  about_mission_title_en: "Our Mission",
  about_mission_title_id: "Misi Kami",
  now_playing_en: "Now Playing",
  now_playing_id: "Daftar Film",
  find_cinema_en: "Find Cinema",
  find_cinema_id: "Cari Bioskop",
  download_mtix_en: "Download m.tix App",
  download_mtix_id: "Download m.tix App",
  news_en: "News",
  news_id: "Artikel",
  newsroom_en: "Newsroom",
  newsroom_id: "Ruang Berita",
  career_en: "Career",
  career_id: "Karir",
  about_en: "About Us",
  about_id: "Tentang Kami",
  product_services_en: "Products & Services",
  product_services_id: "Produk & Layanan",
  our_commitment_en: "Our Commitment",
  our_commitment_id: "Komitmen Kami",
  contact_us_en: "Contact Us",
  contact_us_id: "Hubungi Kami",
  apply_now_en: "Apply Now",
  apply_now_id: "Lamar Sekarang",
  search_en: "Search",
  search_id: "Cari",
  search_location_placeholder_en: "Search malls, cinema locations...",
  search_location_placeholder_id: "Cari lokasi mall dan teater...",
  search_position_placeholder_en: "Search Position...",
  search_position_placeholder_id: "Cari Posisi...",
  all_city_en: "All City",
  all_city_id: "Semua Kota",
  all_location_en: "All Locations",
  all_location_id: "Semua Lokasi",
  all_employment_type_en: "All Employment Type",
  all_employment_type_id: "Semua Jenis Pekerjaan",
  employment_type_en: "Employment Type",
  employment_type_id: "Jenis Pekerjaan",
  ask_us_en: "Ask Us Anything",
  ask_us_id: "Tanya Kami",
  factsheet_logo_en: "Logo",
  factsheet_logo_id: "Logo",
  brand_images_en: "Brand Photos",
  brand_images_id: "Foto Brand",
  privacy_policy_en: "Privacy Policy",
  privacy_policy_id: "Kebijakan Privasi",
  terms_conditions_en: "Terms & Conditions",
  terms_conditions_id: "Syarat & Ketentuan",
  studio_booking_en: "Studio Booking",
  studio_booking_id: "Penyewaan Studio",
  advertising_en: "Advertising",
  advertising_id: "Iklan",
  promotion_en: "Partnership",
  promotion_id: "Kemitraan",
  boc_en: "Board of Commissioners",
  boc_id: "Dewan Komisaris",
  bod_en: "Board of Directors",
  bod_id: "Direksi",
  organization_structure_en: "Organization Structure",
  organization_structure_id: "Struktur Organisasi",
  download_pdf_en: "Download as PDF",
  download_pdf_id: "Unduh sebagai PDF",
  fullscreen_en: "Fullscreen View",
  fullscreen_id: "Tampilan Layar Penuh",
  read_more_en: "Read More",
  read_more_id: "Baca Selengkapnya",
  all_year_en: "All Years",
  all_year_id: "Semua Tahun",
  all_outlets_en: "All Outlets",
  all_outlets_id: "Semua Outlet",
  social_initiatives_en: "Social Initiatives",
  social_initiatives_id: "Kegiatan Sosial",
  learn_more_en: "Learn More",
  learn_more_id: "Pelajari Lebih Lanjut",
  full_time_en: "Full Time",
  full_time_id: "Penuh Waktu",
  download_all_photos_en: "Download All Photos",
  download_all_photos_id: "Unduh Semua Foto",
  download_en: "Download",
  download_id: "Unduh",
  view_en: "View",
  view_id: "Lihat",
  contact_advertise_1_en: "Seen by people across Indonesia",
  contact_advertise_2_en: "Let's advertise with us",
  contact_advertise_1_id: "Dilihat oleh masyarakat seluruh Indonesia",
  contact_advertise_2_id: "Beriklanlah dengan kami",
  digital_products_en: "Digital Products",
  digital_products_id: "Produk Digital",
  venues_other_income_en: "Venue & Others",
  venues_other_income_id: "Venue & Lainnya",
  the_ballroom_en: "The Ballroom",
  the_ballroom_id: "The Ballroom",
  other_income_en: "Others",
  other_income_id: "Lainnya",
  investors_area_en: "Investor Relations",
  investors_area_id: "Hubungan Investor",
  governance_en: "Governance",
  governance_id: "Tata Kelola",
  prospectus_en: "Prospectus",
  prospectus_id: "Prospektus",
  financial_information_en: "Financial Information",
  financial_information_id: "Informasi keuangan",
  disclosure_en: "Disclosure",
  disclosure_id: "Penyingkapan",
  annual_report_en: "Annual Report",
  annual_report_id: "Laporan Tahunan",
  shareholder_information_en: "Shareholder Information",
  shareholder_information_id: "Informasi Pemegang Saham",
  dividend_en: "Dividend",
  dividend_id: "Dividen",
  ir_activities_en: "IR Activities",
  ir_activities_id: "Kegiatan IR",
  supplementary_information_en: "Supplementary Information",
  supplementary_information_id: "Informasi tambahan",
  public_expose_en: "Public Expose",
  public_expose_id: "Paparan Publik",
  code_of_conduct_en: "Code of Conduct",
  code_of_conduct_id: "Kode Etik",
  board_charter_en: "Board Charter",
  board_charter_id: "Piagam Dewan",
  audit_committee_en: "Audit Committee",
  audit_committee_id: "Komite Audit",
  nomination_remuneration_en: "Nomination & Remuneration",
  nomination_remuneration_id: "Nominasi & Remunerasi",
  nomination_remuneration_committee_en: "Nomination & Remuneration Committee",
  nomination_remuneration_committee_id: "Komite Nominasi & Remunerasi",
  internal_audit_en: "Internal Audit",
  internal_audit_id: "Audit Internal ",
  corporate_secretary_en: "Corporate Secretary",
  corporate_secretary_id: "Sekretaris Perusahaan",
  articles_of_association_en: "Articles of Association",
  articles_of_association_id: "Anggaran Dasar",
  financial_report_en: "Financial Report",
  financial_report_id: "Laporan Keuangan",
  financial_overview_en: "Key Financial Data Overview",
  financial_overview_id: "Ikhtisar Data Keuangan Penting",
  newest_en: "Newest - Oldest",
  newest_id: "Terbaru - Terlama",
  oldest_en: "Oldest - Newest",
  oldest_id: "Terlama - Terbaru",
  dividend_policy_en: "Dividend Policy",
  dividend_policy_id: "Kebijakan Dividen",
  dividend_history_en: "Dividend History",
  dividend_history_id: "Riwayat Dividen",
  child_entity_en: "Subsidiaries",
  child_entity_id: "Entitas Anak",
  supporting_institution_en:
    "Capital Market Supporting Institutions and Professions",
  supporting_institution_id: "Lembaga dan Profesi Penunjang Pasar Modal",
  sort_by_en: "Sort By",
  sort_by_id: "Urutkan",
  year_en: "Year",
  year_id: "Tahun",
  dividend_per_share_en: "Dividend per Share",
  dividend_per_share_id: "Dividen per Saham",
  outstanding_shares_en: "Outstanding Shares",
  outstanding_shares_id: "Saham Beredar",
  total_dividend_payment_en: "Total Dividend Payment",
  total_dividend_payment_id: "Jumlah Pembayaran Dividen",
  payment_date_en: "Payment Date",
  payment_date_id: "Tanggal pembayaran",
  date_en: "Date",
  date_id: "Tanggal",
  host_en: "Host",
  host_id: "Penyelenggara",
  title_en: "Title",
  title_id: "Judul",
  desc_en: "Description",
  desc_id: "Deskripsi",
  no_of_shares_en: "Number of Shares",
  no_of_shares_id: "Jumlah Saham",
  stock_performances_en: "Stock Performance",
  stock_performances_id: "Performa Stok",
  download_report_en: "Download Report",
  download_report_id: "Unduh Laporan",
  info_stocks_data_en:
    "Data provided by Yahoo Finance. Please mind the 30 Minutes delay at minimum",
  info_stocks_data_id:
    "Data diambil dari Yahoo Finance. Mohon untuk menunggu selama 30 Menit untuk setiap perubahan harga saham.",
  sustainability_report_en: "Sustainability Report",
  sustainability_report_id: "Laporan Komitmen Keberlanjutan",
  last_update_en: "Last updated",
  last_update_id: "Update terakhir",
  no_data_en: "Data is temporarily unavailable",
  no_data_id: "Data tidak tersedia",
  no_reports_en: "No Reports Found",
  no_reports_id: "Laporan tidak ditemukan",
  all_commitments_en: "All Commitments",
  all_commitments_id: "Semua Komitmen",
  not_found_sustainability_id:
    "Mohon maaf konten Sustainability Commitment yang anda cari tidak ditemukan. Silahkan cek kembali dalam beberapa saat lagi.",
  not_found_sustainability_en:
    "Sorry, the Sustainability Commitment content cannot be found at the moment. Please check again later.",
}
